import $ from 'jquery';

require('magnific-popup');

$(() => {
  const $videoPopupTriggers = $('.js-video-popup');

  if ($videoPopupTriggers.length) {
    $('.js-video-popup').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      iframe: {
        patterns: {
          youtube: {
            index: 'youtube.com',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?autoplay=1',
          },
          youtu_be: {
            index: 'youtu.be',
            id: '/',
            src: '//www.youtube.com/embed/%id%?autoplay=1',
          },
          vimeo: {
            index: 'vimeo.com/',
            id: '/',
            src: '//player.vimeo.com/video/%id%?autoplay=1',
          },
        },
      },
    });
  }
});



// WEBPACK FOOTER //
// ./_components/video-block/index.js